import { createAsyncThunk } from '@reduxjs/toolkit';
import { postUpdateCustomer } from '../services/postUpdateCustomer.service';
import { selectSelectedProject } from 'store/projects/selectors/projectsSelectors';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';

export const updateCustomer = createAsyncThunk(
  'customer/updateCustomer',
  async (data, { getState }) => {
    const customerData = data;

    const state = getState();
    const activeEmployerInfo = selectUserActiveEmployerInfo(state);

    const selectedProject = selectSelectedProject(state);
    const businessId = selectedProject.business_id;
    if (!businessId) {
      throw new Error('No business id given');
    }

    const customerUpdateData = await postUpdateCustomer(
      businessId,
      customerData,
      activeEmployerInfo
    );

    return customerUpdateData;
  }
);
